var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { QueryCondition, QUERY_CONDITION_TYPE, IorderType } from './QueryCondition';
import { DBError, DBErrorType } from '../model/Error/DBError';
import { Result } from '../model/Result';
import { DataError, DataErrorType } from '../model/Error/DataError';
import { isALowerB, wrapResult } from '../tools/utils';
import { BaseDatabase } from './BaseDatabase';
import Log from '../tools/Log';
import { OfflineData } from '../model/OfflineData';
var MAX_OPEN_FAIL_COUNT = 2;
var IndexedDatabase = /** @class */ (function (_super) {
    __extends(IndexedDatabase, _super);
    function IndexedDatabase(options) {
        var _this_1 = _super.call(this, options) || this;
        _this_1.openErrorCount = 0;
        return _this_1;
        // todo处理，之前把处理offlinedata 通过装饰器写死在了里面
        // this.wrapResult(options.wrap)
    }
    /**
     * 对indexDB返回的结果进行处理todo， 暂不影响
     * @param wrapList
     */
    // wrapResult(wrapList: Array<any>) {
    //     let wrapCount = wrapList.length;
    //     for (let index = 0; index < wrapCount; index++) {
    //         const wrap = wrapList[index];
    //         let key = Object.keys(wrap)[0];
    //         if (this[key]) {
    //             Object.defineProperty(this, key, {
    //                 value: function () {
    //                     console.log("meow ~");
    //                     let promise = this[key].apply(this, arguments);
    //                     promise.then((result) => {
    //                         if (result.error) {
    //                             return result;
    //                         }
    //                         if (wrap[key]) {
    //                             return wrap[key](result);
    //                         }
    //                     }).catch((error) => {
    //                         return error
    //                     })
    //                 }
    //             })
    //         } else {
    //             console.error('不存在此方法：' + key);
    //         }
    //     }
    // }
    IndexedDatabase.prototype.init = function (destroy) {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
                        var _this, dbError, deleteResult, request;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    Log.time('IndexedDatabaseInit');
                                    _this = this;
                                    _this._indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
                                    if (!_this._indexedDB) {
                                        Log.error('IndexedDatabase', 'NOT_SUPPORT_INDEXEDDB');
                                        _this.database = null;
                                        dbError = new DBError(DBErrorType.NOT_SUPPORT_INDEXEDDB);
                                        resolve(new Result(dbError));
                                        return [2 /*return*/];
                                    }
                                    if (!destroy) return [3 /*break*/, 2];
                                    return [4 /*yield*/, this.deleteDB()];
                                case 1:
                                    deleteResult = _a.sent();
                                    if (deleteResult.error) {
                                        Log.error(deleteResult.error);
                                    }
                                    _a.label = 2;
                                case 2:
                                    // firefox下open会报错
                                    try {
                                        request = _this._indexedDB.open(_this._dbName, _this._dbVersion);
                                    }
                                    catch (error) {
                                        Log.error('IndexedDatabase', 'open() error', error);
                                        _this.database = null;
                                        dbError = new DBError(DBErrorType.OPEN_FAIL, error.name || error.message || '');
                                        resolve(new Result(dbError));
                                        return [2 /*return*/];
                                    }
                                    request.onerror = function (event) {
                                        return __awaiter(this, void 0, void 0, function () {
                                            var suggestVersion, errorMessage, reg, openResult;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        _this.openErrorCount++; // 错误次数+1
                                                        if (request.error && request.error.name === 'InvalidStateError') {
                                                            event.preventDefault(); // fixfox 隐私模式下打开会有问题。 网上的方法，试试看。https://stackoverflow.com/questions/13972385/invalidstateerror-while-opening-indexeddb-in-firefox
                                                        }
                                                        Log.error('IndexedDatabase', 'init() onerror()', event);
                                                        _this.database = null;
                                                        if (!(_this.openErrorCount < MAX_OPEN_FAIL_COUNT && event && event.target && event.target.error && event.target.error.name === 'VersionError')) return [3 /*break*/, 2];
                                                        suggestVersion = _this._dbVersion + 1;
                                                        errorMessage = event.target.error.message;
                                                        reg = /\((\d+)\).*\((\d+)\)/.exec(errorMessage);
                                                        reg && (suggestVersion = Number(reg[2])); // chrome浏览器这种返回的message类似提示为："The requested version (1) is less than the existing version (2)."  safari返回的错误提示语是"An attempt was made to open a database using a lower version than the existing version."
                                                        _this._dbVersion = suggestVersion; // 修改版本号 然后重新初始化一次
                                                        return [4 /*yield*/, _this.init()];
                                                    case 1:
                                                        openResult = _a.sent();
                                                        resolve(openResult);
                                                        return [2 /*return*/];
                                                    case 2:
                                                        dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                                                        resolve(new Result(dbError));
                                                        return [2 /*return*/];
                                                }
                                            });
                                        });
                                    };
                                    request.onsuccess = function (event) {
                                        Log.timeEnd('IndexedDatabaseInit');
                                        _this.database = request.result;
                                        // 监听数据库升级事件
                                        _this.database.onversionchange = function () {
                                            window.dispatchEvent(new Event('OnTencentDocsDBVersionChanged'));
                                        };
                                        resolve(new Result(undefined, request.result));
                                    };
                                    request.onblocked = function (event) {
                                        Log.error('IndexedDatabase', 'init() onblocked()', event);
                                        _this.database = null;
                                        dbError = new DBError(DBErrorType.DB_BLOCKED);
                                        resolve(new Result(dbError, event));
                                    };
                                    request.onupgradeneeded = function (event) {
                                        Log.warn('IndexedDatabase', 'init() onupgradeneeded()', event);
                                        var database = event.target.result;
                                        database.objectStoreNames && _this._tables.forEach(function (table) {
                                            if (!database.objectStoreNames.contains(table.tableName)) {
                                                var objectStore_1;
                                                if (table.keyName) {
                                                    objectStore_1 = database.createObjectStore(table.tableName, {
                                                        keyPath: table.keyName,
                                                    });
                                                }
                                                else {
                                                    objectStore_1 = database.createObjectStore(table.tableName, {
                                                        autoIncrement: true,
                                                    });
                                                }
                                                if (table.indexs) {
                                                    table.indexs.forEach(function (indexName) {
                                                        objectStore_1.createIndex(indexName, indexName, { unique: false });
                                                    });
                                                }
                                            }
                                        });
                                    };
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    IndexedDatabase.prototype.deleteDB = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var error;
                        var deleteRequest = _this_1._indexedDB.deleteDatabase(_this_1._dbName);
                        deleteRequest.onsuccess = function () {
                            resolve(new Result(error, true));
                        };
                        deleteRequest.onerror = function (event) {
                            error = new DBError(DBErrorType.REQUEST_ERROR, event);
                            resolve(new Result(error));
                        };
                    })];
            });
        });
    };
    /**
     * 封装一些通用异常处理
     */
    IndexedDatabase.prototype.bindCommonEvent = function (request, transaction, timeout, ms) {
        transaction.onabort = function () {
            Log.error('IndexedDatabase', 'bindCommonEvent() onabort', 'TransactionAbortError');
            var error = new Error('TransactionAbortError');
            window.dispatchEvent(new Event('OnDBTransactionAbort'));
            timeout(new Result(error));
        };
        transaction.onerror = function () {
            Log.error('IndexedDatabase', 'bindCommonEvent() onerror', 'UnKnownTransactionError');
            var error = new Error('UnKnownTransactionError');
            window.dispatchEvent(new Event('OnDBTransactionError'));
            timeout(new Result(error));
        };
        // setTimeout(() => {
        //     if (request.readyState === 'pending') {
        //         transaction.abort(); // 结束事务
        //         this.disConnect();
        //         let error = new Error('UserAbortTransactionError'); // 上面的abort有的时候无效，那就干脆自己主动结束掉吧  唉~ 坑啊  这样并不能解决连接pending的问题 只是让外层能够知道查询失败了
        //         timeout(new Result(error));
        //         window.dispatchEvent(new Event('OnDBTransactionTimeOut'));
        //         Log.error('IndexedDatabase', 'bindCommonEvent() timeOut.  call abort()');
        //     }
        // }, ms);
    };
    /**
     * 获取数据库连接 开启事务 进行查询或者修改
     * @param tableName
     * @param where
     * @param mode
     */
    IndexedDatabase.prototype.getDBConnection = function (tableName, where, mode, resolve, reject) {
        var request;
        var transaction;
        var objectStore;
        try {
            transaction = this.database.transaction([tableName], mode);
            objectStore = transaction.objectStore(tableName);
            if (where && where.hasIndex()) {
                var indexKey = where.getIndexKey();
                var index = objectStore.index(indexKey);
                var range = undefined;
                var position = -1;
                if (where) {
                    for (var i = 0; i < where.conditions.length; i++) {
                        var condition = where.conditions[i];
                        if (condition.column !== indexKey) { // 和index不是同一列 直接略过
                            continue;
                        }
                        switch (condition.type) {
                            case QUERY_CONDITION_TYPE.ONLY:
                                range = IDBKeyRange.only(condition.value);
                                position = i;
                                break;
                            case QUERY_CONDITION_TYPE.LOWER_BOUND:
                                var lowerValue = condition.value;
                                range = IDBKeyRange.lowerBound(lowerValue.lower, lowerValue.open);
                                position = i;
                                break;
                            case QUERY_CONDITION_TYPE.UPPER_BOUND:
                                var upperValue = condition.value;
                                range = IDBKeyRange.upperBound(upperValue.upper, upperValue.open);
                                position = i;
                                break;
                            case QUERY_CONDITION_TYPE.BOUND: {
                                var boundValue = condition.value;
                                range = IDBKeyRange.bound(boundValue.lower, boundValue.upper, boundValue.lowerOpen, boundValue.upperOpen);
                                position = i;
                                break;
                            }
                        }
                        if (position !== -1) {
                            where.conditions.splice(position, 1); // 删除这个条件 因为IDBKeyRange只支持一个条件 所以找到一个可以转换为range的条件后，就可以退出了，然后要在所有条件里面删除找到的这个
                            break;
                        }
                    }
                }
                request = index.openCursor(range);
            }
            else {
                request = objectStore.openCursor();
            }
            // 设置超时
            this.bindCommonEvent(request, transaction, resolve, 10 * 1000);
        }
        catch (e) {
            Log.error('IndexedDatabase', 'getDBConnection() error', e);
            return new Result(e);
        }
        Log.debug('IndexedDatabase', 'getDBConnection() done.');
        return new Result(undefined, {
            request: request,
            transaction: transaction,
            objectStore: objectStore,
        });
    };
    IndexedDatabase.prototype.set = function (tableName, data) {
        Log.time('IndexedDatabaseSet', tableName, data);
        return this.setOrUpdate('Set', tableName, data);
    };
    IndexedDatabase.prototype.update = function (tableName, data) {
        Log.time('IndexedDatabaseUpdate', tableName, data);
        return this.setOrUpdate('Update', tableName, data);
    };
    IndexedDatabase.prototype.setOrUpdate = function (type, tableName, data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this_1 = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
                        var dbError, checkResult, connection, objectStore, transaction, request;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.checkAndOpenTable(tableName)];
                                case 1:
                                    checkResult = _a.sent();
                                    if (checkResult.error) {
                                        dbError = new DBError(DBErrorType.CHECK_FAIL);
                                        resolve(new Result(dbError));
                                        return [2 /*return*/];
                                    }
                                    connection = this.getDBConnection(tableName, undefined, 'readwrite', resolve, reject);
                                    if (connection.error) {
                                        resolve(new Result(connection.error));
                                        return [2 /*return*/];
                                    }
                                    objectStore = connection.data.objectStore;
                                    transaction = connection.data.transaction;
                                    if (type === 'set') {
                                        request = objectStore.add(data);
                                    }
                                    else {
                                        try {
                                            request = objectStore.put(data, data.__primaryKey);
                                        }
                                        catch (e) {
                                            request = objectStore.put(data);
                                        }
                                    }
                                    request.onerror = function (event) {
                                        dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                                    };
                                    transaction.oncomplete = function () {
                                        Log.timeEnd("IndexedDatabase" + type);
                                        resolve(new Result(dbError, true));
                                    };
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * 增量更新内容
     * @param tableName 表名
     * @param where 条件查询
     * @param toBeUpdated 要更新的字段和数据
     */
    IndexedDatabase.prototype.updateField = function (tableName, where, toBeUpdated) {
        var _this_1 = this;
        Log.time('IndexedDatabaseUpdateField', tableName, where, toBeUpdated);
        return new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
            var _this, dbError, checkResult, connection, request, transaction, newResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, this.checkAndOpenTable(tableName)];
                    case 1:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            dbError = new DBError(DBErrorType.CHECK_FAIL);
                            resolve(new Result(dbError));
                            return [2 /*return*/];
                        }
                        connection = this.getDBConnection(tableName, where, 'readwrite', resolve, reject);
                        if (connection.error) {
                            resolve(new Result(connection.error));
                            return [2 /*return*/];
                        }
                        request = connection.data.request;
                        transaction = connection.data.transaction;
                        request.onerror = function (event) {
                            dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                        };
                        newResult = new Array();
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                var item = cursor.value;
                                if (_this.checkCondition(item, where)) {
                                    var newValue = Object.assign(item, toBeUpdated);
                                    var updateRequest = cursor.update(newValue);
                                    updateRequest.onerror = function (event) {
                                        dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                                    };
                                    newResult.push(newValue);
                                }
                                cursor.continue();
                            }
                        };
                        transaction.oncomplete = function () {
                            Log.timeEnd('IndexedDatabaseUpdateField');
                            resolve(new Result(dbError, newResult));
                        };
                        return [2 /*return*/];
                }
            });
        }); });
    };
    IndexedDatabase.prototype.updateMultiTableData = function (multiData) {
        var _this_1 = this;
        Log.time('IndexedDatabaseUpdateMultiTableData', multiData);
        return new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
            var dbError, _i, multiData_1, item, checkResult, tableNameList, transaction_1, totalCount_1, successCount_1, errorCount_1;
            var _this_1 = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _i = 0, multiData_1 = multiData;
                        _a.label = 1;
                    case 1:
                        if (!(_i < multiData_1.length)) return [3 /*break*/, 4];
                        item = multiData_1[_i];
                        return [4 /*yield*/, this.checkAndOpenTable(item.tableName)];
                    case 2:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            dbError = new DBError(DBErrorType.CHECK_FAIL);
                            resolve(new Result(dbError));
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        tableNameList = multiData.map(function (item) {
                            return item.tableName;
                        });
                        try {
                            transaction_1 = this.database.transaction(tableNameList, 'readwrite');
                            totalCount_1 = multiData.length, successCount_1 = 0, errorCount_1 = 0;
                            multiData.forEach(function (item) {
                                var objectStore = transaction_1.objectStore(item.tableName);
                                var request;
                                try {
                                    request = objectStore.put(item.data, item.data.__primaryKey);
                                }
                                catch (e) {
                                    request = objectStore.put(item.data);
                                }
                                request.onsuccess = function (event) {
                                    successCount_1++;
                                };
                                request.onerror = function (event) {
                                    errorCount_1++;
                                    Log.error(event);
                                };
                                _this_1.bindCommonEvent(request, transaction_1, resolve, 10 * 1000);
                            });
                            transaction_1.oncomplete = function () {
                                Log.timeEnd('IndexedDatabaseUpdateMultiTableData');
                                if (errorCount_1 > 0) {
                                    Log.error('IndexedDatabaseUpdateMultiTableData', 'errorCount=', errorCount_1);
                                    dbError = new DBError(DBErrorType.REQUEST_ERROR);
                                    resolve(new Result(dbError, { totalCount: totalCount_1, successCount: successCount_1, errorCount: errorCount_1 }));
                                }
                                else {
                                    resolve(new Result(undefined, { totalCount: totalCount_1, successCount: successCount_1, errorCount: errorCount_1 }));
                                }
                            };
                        }
                        catch (e) {
                            Log.error('IndexedDatabase', 'updateMultiTableData() onError', e);
                            resolve(new Result(e));
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    IndexedDatabase.prototype.delete = function (tableName, where) {
        var _this_1 = this;
        Log.time('IndexedDatabaseDelete', tableName, where);
        return new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
            var _this, dbError, checkResult, connection, request, transaction, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, this.checkAndOpenTable(tableName)];
                    case 1:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            dbError = new DBError(DBErrorType.CHECK_FAIL);
                            resolve(new Result(dbError));
                            return [2 /*return*/];
                        }
                        connection = this.getDBConnection(tableName, where, 'readwrite', resolve, reject);
                        if (connection.error) {
                            resolve(new Result(connection.error));
                            return [2 /*return*/];
                        }
                        request = connection.data.request;
                        transaction = connection.data.transaction;
                        request.onerror = function (event) {
                            dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                        };
                        result = new Array();
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                var item = cursor.value;
                                if (_this.checkCondition(item, where)) {
                                    cursor.delete();
                                    result.push(item);
                                }
                                cursor.continue();
                            }
                        };
                        transaction.oncomplete = function () {
                            Log.timeEnd('IndexedDatabaseDelete');
                            resolve(new Result(dbError, result));
                        };
                        return [2 /*return*/];
                }
            });
        }); });
    };
    IndexedDatabase.prototype.deleteAndWrite = function (tableName, where, newData) {
        var _this_1 = this;
        Log.time('IndexedDatabaseDeleteAndWrite', tableName, where);
        return new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
            var _this, dbError, checkResult, connection, request, objectStore, transaction, deleteCount, writeCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, this.checkAndOpenTable(tableName)];
                    case 1:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            dbError = new DBError(DBErrorType.CHECK_FAIL);
                            resolve(new Result(dbError));
                            return [2 /*return*/];
                        }
                        connection = this.getDBConnection(tableName, where, 'readwrite', resolve, reject);
                        if (connection.error) {
                            resolve(new Result(connection.error));
                            return [2 /*return*/];
                        }
                        request = connection.data.request;
                        objectStore = connection.data.objectStore;
                        transaction = connection.data.transaction;
                        request.onerror = function (event) {
                            dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                        };
                        deleteCount = 0, writeCount = 0;
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                var item = cursor.value;
                                if (_this.checkCondition(item, where)) {
                                    cursor.delete();
                                    deleteCount++;
                                }
                                cursor.continue();
                            }
                            else {
                                // 开始写入
                                newData.forEach(function (item) {
                                    var insertRequest = objectStore.put(item);
                                    insertRequest.onsuccess = function (e) {
                                        writeCount++;
                                    };
                                });
                            }
                        };
                        transaction.oncomplete = function () {
                            Log.timeEnd('IndexedDatabaseDeleteAndWrite');
                            Log.log('IndexedDatabaseDeleteAndWrite', deleteCount, writeCount);
                            resolve(new Result(dbError, { deleteCount: deleteCount, writeCount: writeCount }));
                        };
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 单条查询
     * @param tableName
     * @param where
     * @param onSuccess
     * @param onError
     */
    IndexedDatabase.prototype.get = function (tableName, where) {
        return __awaiter(this, void 0, void 0, function () {
            var queryResult, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        where.limit(1);
                        return [4 /*yield*/, this.getAll(tableName, where)];
                    case 1:
                        queryResult = _a.sent();
                        if (queryResult.error) {
                            return [2 /*return*/, new Result(queryResult.error)];
                        }
                        data = queryResult.data;
                        if (data.length === 0) {
                            // 没有找到符合条件内容
                            return [2 /*return*/, new Result(new DataError(DataErrorType.NO_RESULT_ERROR, '没有找到符合条件的内容'))];
                        }
                        return [2 /*return*/, new Result(undefined, data[0])];
                }
            });
        });
    };
    /**
     * 多条查询内容
     * @param tableName
     * @param where 所有条件都是“与”关系
     * @param onSuccess
     * @param onError
     */
    IndexedDatabase.prototype.getAll = function (tableName, where) {
        var _this_1 = this;
        Log.time('IndexedDatabaseGetAll', tableName, where);
        return new Promise(function (resolve, reject) { return __awaiter(_this_1, void 0, void 0, function () {
            var _this, dbError, checkResult, connection, request, transaction, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _this = this;
                        return [4 /*yield*/, this.checkAndOpenTable(tableName)];
                    case 1:
                        checkResult = _a.sent();
                        if (checkResult.error) {
                            dbError = new DBError(DBErrorType.CHECK_FAIL);
                            resolve(new Result(dbError));
                            return [2 /*return*/];
                        }
                        connection = this.getDBConnection(tableName, where, 'readonly', resolve, reject);
                        if (connection.error) {
                            resolve(new Result(connection.error));
                            return [2 /*return*/];
                        }
                        request = connection.data.request;
                        transaction = connection.data.transaction;
                        request.onerror = function (event) {
                            dbError = new DBError(DBErrorType.REQUEST_ERROR, event);
                        };
                        result = new Array();
                        request.onsuccess = function (event) {
                            var cursor = event.target.result;
                            if (cursor) {
                                var item = cursor.value;
                                if (_this.checkCondition(item, where)) {
                                    item.__primaryKey = cursor.primaryKey; // 指定下主键 更新的时候可以用
                                    result.push(item);
                                }
                                if (!where.hasOrder() && result.length >= where.limitSize() + where.offsetCount()) {
                                    // 没有排序要求，而且查询的数量已经操作限度，那就不用继续了
                                    // 其中数量限度为  offset+limit 
                                    return;
                                }
                                else {
                                    cursor.continue();
                                }
                            }
                        };
                        transaction.oncomplete = function () {
                            if (result.length > 0 && where.hasOrder()) {
                                // 优先按最前面字段排序，遇到一样的值，再按后面的字段排序
                                result = _this.sortResult(result, where.getOrders());
                            }
                            // 条数限制  偏移量处理
                            var begin = where.offsetCount();
                            var end = begin + where.limitSize();
                            result = result.slice(begin, end);
                            Log.timeEnd('IndexedDatabaseGetAll');
                            resolve(new Result(dbError, result));
                        };
                        return [2 /*return*/];
                }
            });
        }); });
    };
    IndexedDatabase.prototype.sortResult = function (result, orders) {
        // orders按添加的顺序反向来排  这样先添加的优先级最高
        orders.reverse().forEach(function (value, index) {
            result.sort(function (a, b) {
                var r = 0;
                switch (value.type) {
                    case IorderType.INCREASE:
                        r = a[value.key] > b[value.key] ? 1 : a[value.key] === b[value.key] ? 0 : -1;
                        break;
                    case IorderType.DECREASE:
                        r = a[value.key] > b[value.key] ? -1 : a[value.key] === b[value.key] ? 0 : 1;
                        break;
                    case IorderType.INCREASE_BY_TEXT:
                        r = a[value.key].localeCompare(b[value.key]);
                        break;
                    case IorderType.DECREASE_BY_TEXT:
                        r = b[value.key].localeCompare(a[value.key]);
                        break;
                }
                return r;
            });
        });
        return result;
    };
    /**
     * 条件校验函数
     * @param item
     * @param where
     */
    IndexedDatabase.prototype.checkCondition = function (item, where) {
        var flag = true;
        for (var i = 0; i < where.conditions.length; i++) {
            var condition = where.conditions[i];
            switch (condition.type) {
                case QUERY_CONDITION_TYPE.ONLY:
                    if (item[condition.column] !== condition.value) {
                        flag = false;
                    }
                    break;
                case QUERY_CONDITION_TYPE.LOWER_BOUND:
                    var lowerValue = condition.value;
                    if (isALowerB(item[condition.column], lowerValue.lower, !lowerValue.open)) {
                        flag = false;
                    }
                    break;
                case QUERY_CONDITION_TYPE.UPPER_BOUND:
                    var upperValue = condition.value;
                    if (isALowerB(upperValue.upper, item[condition.column], !upperValue.open)) {
                        flag = false;
                    }
                    break;
                case QUERY_CONDITION_TYPE.IN: {
                    var optionValue = condition.value;
                    if (optionValue.indexOf(item[condition.column]) === -1) {
                        flag = false;
                    }
                    break;
                }
                case QUERY_CONDITION_TYPE.BOUND: {
                    var boundValue = condition.value;
                    if (isALowerB(item[condition.column], boundValue.lower, !boundValue.lowerOpen) || isALowerB(boundValue.upper, item[condition.column], !boundValue.upperOpen)) {
                        flag = false;
                    }
                    break;
                }
                case QUERY_CONDITION_TYPE.NOT_IN: {
                    var optionValue = condition.value;
                    if (optionValue.indexOf(item[condition.column]) !== -1) {
                        flag = false;
                    }
                    break;
                }
            }
            if (!flag) {
                break;
            }
        }
        return flag;
    };
    /**
     * 检查table是否可用  同时会检查database是否可用 如果可用会返回true
     * @param tableName
     */
    IndexedDatabase.prototype.checkAndOpenTable = function (tableName) {
        return __awaiter(this, void 0, void 0, function () {
            var _this, reInitResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        _this = this;
                        if (!(!_this.database && _this._canAutoResume)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.init()];
                    case 1:
                        reInitResult = _a.sent();
                        if (reInitResult.error) {
                            Log.error('IndexedDatabase', 'checkAndOpenTable()', tableName, reInitResult.error);
                            return [2 /*return*/, new Result(new DBError(DBErrorType.CHECK_FAIL, 'database is not available.'))];
                        }
                        _a.label = 2;
                    case 2:
                        if (!_this.database) { // 额外再检查一下
                            Log.error('IndexedDatabase', 'checkAndOpenTable()', tableName, 'database is not available.');
                            return [2 /*return*/, new Result(new DBError(DBErrorType.CHECK_FAIL, 'database is not available.'))];
                        }
                        if (!_this.database.objectStoreNames.contains(tableName)) {
                            Log.error('IndexedDatabase', 'checkAndOpenTable()', tableName, "table " + tableName + " is not available.");
                            return [2 /*return*/, new Result(new DBError(DBErrorType.CHECK_FAIL, "table " + tableName + " is not available."))];
                        }
                        return [2 /*return*/, new Result(undefined, true)];
                    case 3:
                        e_1 = _a.sent();
                        Log.error('IndexedDatabase', 'checkAndOpenTable()', tableName, 'UnknownError');
                        return [2 /*return*/, new Result(e_1, false)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDatabase.prototype.setAutoResume = function (canAutoResume) {
        if (canAutoResume === void 0) { canAutoResume = true; }
        this._canAutoResume = canAutoResume;
    };
    /**
     * 关闭数据库断开连接
     */
    IndexedDatabase.prototype.disConnect = function (canAutoResume) {
        if (canAutoResume === void 0) { canAutoResume = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        Log.log('IndexedDatabase', 'disConnect()', canAutoResume, this.database);
                        this._canAutoResume = canAutoResume;
                        _a = this.database;
                        if (!_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.database.close()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        _a;
                        this.database = undefined;
                        return [2 /*return*/, Promise.resolve(new Result(undefined, true))];
                    case 3:
                        e_2 = _b.sent();
                        Log.error('IndexedDatabase', 'disConnect() Error.', e_2);
                        return [2 /*return*/, Promise.resolve(new Result(undefined, false))];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IndexedDatabase._uuid = Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
    __decorate([
        wrapResult(OfflineData, 'OfflineData') // 针对OfflineData表的查询，对结果进行对象化
        ,
        wrapResult(OfflineData, 'DocumentData') // 针对DocumentData表的查询，对结果进行对象化
        ,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, QueryCondition]),
        __metadata("design:returntype", void 0)
    ], IndexedDatabase.prototype, "getAll", null);
    return IndexedDatabase;
}(BaseDatabase));
export { IndexedDatabase };
//# sourceMappingURL=IndexedDatabase.js.map